export default "__VITE_ASSET__DwzmXGPg__"